import { useContext } from "react";
import PermissionContext from "../../contexts/PermissionContext";
import { extractUserPermission } from "../../helpers/extract";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Select from "react-select";
import { API, graphqlOperation } from "aws-amplify";
import { updateProductLibAppIAM } from "../../graphql/mutations";
import { UserRoleOptions } from "../../constants/enum";

interface IFormInputs {
  username: string;
  name: string;
  email: string;
  role: { value?: string; label?: string };
}

const PermissionSchema: any = yup
  .object({
    username: yup.string().required(),
    name: yup.string().defined(),
    email: yup.string().email("Must be a valid email").required(),
    role: yup
      .object()
      .shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
      .required(),
  })
  .required();

function UserPermissionUpdateForm() {
  const navigate = useNavigate();
  const { permission } = useContext(PermissionContext);
  const permissionInfo = extractUserPermission(permission);
  
  const onSubmit = async (data: IFormInputs) => {
    const permission = {
      ...data,
      id: permissionInfo.id,
      role: data.role.value,
    };
    const result = await API.graphql(graphqlOperation(updateProductLibAppIAM, { input: permission }));
    if (result) {
      navigate("/userPermissions", { replace: true });
    }
  };

  const methods = useForm<IFormInputs>({
    resolver: yupResolver(PermissionSchema),
    defaultValues: {
      name: permissionInfo.name,
      username: permissionInfo.username,
      email: permissionInfo.email,
      role: UserRoleOptions.find((r:any)=>(r.value.toLowerCase() === permissionInfo.role.toLowerCase())),
    },
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = methods;

  return (
    <div className="block w-full lg:w-3/5 mx-2 rounded-lg bg-white p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="relative mb-6">
            <div className="w-full px-3 mb-6 md:mb-0">
              <label
                className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
                htmlFor="grid-status"
              >
                Role
              </label>
              <Controller
                name="role"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    className="text-sm font-normal basic-single"
                    classNamePrefix="select"
                    placeholder="Role"
                    isDisabled={isSubmitting}
                    options={UserRoleOptions}
                  />
                )}
              />
            </div>

            <div className="w-full px-3 mt-4 mb-6 md:mb-0">
              <label
                className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
                htmlFor="grid-first-name"
              >
                Name
              </label>
              <input
                className="form-input-control-panel-2"
                id="grid-first-name"
                type="text"
                placeholder="Name"
                {...register("name")}
              />
              {errors.name ? (
                <small className="font-light text-red-500">
                  {errors.name.message}
                </small>
              ) : (
                ""
              )}
            </div>

            <div className="w-full px-3 mt-4 mb-6 md:mb-0">
              <label
                className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
                htmlFor="grid-first-name"
              >
                Username
              </label>
              <input
                className="form-input-control-panel-2"
                id="grid-first-name"
                type="text"
                placeholder="Username"
                {...register("username")}
              />
              {errors.username ? (
                <small className="font-light text-red-500">
                  {errors.username.message}
                </small>
              ) : (
                ""
              )}
            </div>

            <div className="w-full px-3 mt-4 mb-6 md:mb-0">
              <label
                className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
                htmlFor="grid-first-name"
              >
                Email
              </label>
              <input
                className="form-input-control-panel-2"
                id="grid-first-name"
                type="text"
                placeholder="Email"
                {...register("email")}
              />
              {errors.email ? (
                <small className="font-light text-red-500">
                  {errors.email.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 px-3">
            <button
              className="btn-back"
              type="button"
              disabled={isSubmitting}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </button>
            <button
              className="btn-submit"
              type="submit"
              disabled={Object.keys(errors).length > 0}
            >
              Submit
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
export default UserPermissionUpdateForm;
